import { OperationResult } from '@urql/core';

import { Team } from '@wetransfer/transfer/hooks/useCurrentTeam/useCurrentUserTeamsQuery';

import {
  CreateTeamForOwnAccountMutationResponse,
  useCreateTeamForOwnAccountMutation,
} from './useCreateTeamForOwnAccountMutation';

export function useCreateTeamForOwnAccount(): {
  team: Team;
  errors: string[];
  fetching: boolean;
  createTeamForOwnAccount(): Promise<
    OperationResult<CreateTeamForOwnAccountMutationResponse>
  >;
} {
  const [{ data, fetching }, createTeamForOwnAccount] =
    useCreateTeamForOwnAccountMutation();

  return {
    team: data?.createTeamForOwnAccount.team,
    errors: data?.createTeamForOwnAccount.errors,
    fetching,
    createTeamForOwnAccount,
  };
}
